import styled from 'styled-components';
import { Link } from '@cko/primitives';

export const SkipLinkComponent = styled(Link)`
  position: absolute;
  transform: translateY(-500%);
  z-index: 100;
  opacity: 0;

  &:focus {
    transition: 325ms;
    left: 50%;
    transform: translateY(0);
    color: var(--base-bg-oninvert-secondary);
    text-decoration: none;
    outline-offset: 0;
    opacity: 1;
    outline-color: var(--control-border-focus-ring);
    background-color: var(--base-bg-primary);
    outline-width: var(--border-b-soybean);
    border-radius: var(--border-r-seed);
    padding: var(--layout-sandgrain) var(--layout-shoebox);
  }
`;
